module.exports = __webpack_public_path__ + "static/media/ChievoVerona.531c503c.png";